export const resumeData = `<h2>Summary</h2>
                <p>Web development — front- and back-end, with particular focus on NodeJs/Express but penchant for problem solving. Conversant and experienced in AWS Cloud infrastructure including CLI and SDK methods for working in S3, EC2 and serverless architectures such as API Gateway-Lambda-DynamoDB.</p>

                <h2>Experience</h2>
                
                <h3>Full-stack Web developer for <a href="https://gulfstream.com" target="_blank">Gulfstream Aerospace</a></h3>
                <p><em>Marketing Department</em></p>
                <p><strong>October 2017-present.</strong> Work with small technical team providing and supporting tools for Marketing and the larger organization, as well as maintain and implement the chief marketing website, <a href="https://gulfstream.com" target="_blank">Gulfstream.com</a>.</p>
                <table class="ui striped table">
                    <tr>
                        <td>Other tasks:</td>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Work in webpack/babel/npm environment to build internal tools as single-page applications that help us manage data important to our department and larger business.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Work in AWS CLI and console to build and support our cloud infrastructure, including a custom serverless API operating on an API Gateway-Lambda-DynamoDB chain.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Work in AWS CLI with convenience Bash scripting to host our single-page applications in S3. 
                        </td>
                    </tr>
                </table>
                
                <h3>Audience Editor/Online Editor for The Island Packet / <a href="http://www.islandpacket.com" target="_blank" data-toggle="tooltip" title="The Island Packet website">islandpacket.com</a></h3>
                <p><em>McClatchy Newspapers Inc. market <a href="https://www.google.com/maps/place/10+Buck+Island+Rd,+Bluffton,+SC+29910/@32.2366681,-81.1952835,10.06z/data=!4m5!3m4!1s0x88fb896b0131975d:0x7a80da4097397eb1!8m2!3d32.277908!4d-80.8737302" target="_blank">in the South Carolina Lowcountry</a></em></p>
                <p><strong>June 2013-October 2017.</strong> Influenced and trained editors and staff of The Island Packet and The Beaufort Gazette for audience-centered news selection, editing and publication. As online editor, I managed digital news development
                    and presentation.</p>
                <table class="ui table striped">
                    <tr>
                        <td>
                            Focused on driving web traffic with aggressive year-over-year story and video growth goals, using tools such as Adobe Analytics and Chartbeat.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Coded and maintained specialty products such as traffic camera and statewide realtime vehicle count tools.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Coded and maintained databases, including local and state public salaries, local crime reports, property transfers and restaurant inspections.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Helped develop and deploy social media and SEO strategies
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Used journalism skills including editing, reporting and writing to optimize content for usability and digestibility.
                        </td>
                    </tr>
                </table>
                <h3>Teaching Assistant, <a href="https://pe.gatech.edu/computing/georgia-tech-coding-boot-camp" target="_blank" data-toggle="tooltip" title="Ga. Tech Coding Bootcamp info">Ga. Tech Full Stack Coding Bootcamp</a></h3>
                <p><strong>August 2017-present.</strong> Moonlighting role. Assist coding instructor on an on-call basis, helping coach/instruct students to ensure success in understanding coding skills at Ga. Tech Savannah campus.</p>
                <h3>Web producer for The State Newspaper / <a title="The State Newspaper website" data-toggle="tooltip" href="http://www.thestate.com" target="_blank">thestate.com</a></h3>
                <p><em>McClatchy Newspapers Inc. market in <a href="https://www.google.com/maps/place/1401+Shop+Rd,+Columbia,+SC+29201/@34.0156106,-81.1848621,10z/data=!4m5!3m4!1s0x88f8baed37541c8b:0x8cabad8a6f9560e9!8m2!3d33.9704592!4d-81.0099237" target="_blank">South Carolina's capitol</a></em></p>
                <p><strong>Sept. 2005-June 2013.</strong> Web producer and reporter</p>
                <table class="ui striped table fluid">
                    <tr>
                        <td>
                            Professionally managed daily news cycle on thestate.com from early morning to mid-afternoon using roles as editor, copy editor, reporter, social media manager, analytics monitor, visuals editor, marketing professional and multimedia producer.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Solved site challenges with technical tools, including HTML, CSS, JavaScript and template management to leverage local and syndicated content and deliver on internal requests.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Helped make thestate.com one of South Carolina's dominant media Web sites from 2005 to the present by publishing breaking news online, writing traffic-driving and SEO-friendly headlines, using analytics to place content, writing and editing high-traffic
                            breaking news stories and adopting new tools, including social media, mobile platforms, text alerts/push notifications and email newsletters.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Earned national recognition from AP for increasing AP Video streams on thestate.com in 2010. My in-cycle and design promotional efforts doubled and in some weeks tripled streams over prior period.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Worked closely on design of sports pay site, gogamecocks.com, launched in Sept. 2010, as well as 2008 and 2012 redesigns of thestate.com.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Developed and managed thestate.com’s <a href="http://facebook.com/thestatenews" target="_blank" title="The State Facebook page" data-toggle="tooltip">Facebook pages</a> and led early deployment of the market's <a href="http://twitter.com/thestate"
                                target="_blank" title="The State Twitter feed" data-toggle="tooltip">Twitter handle</a> to accomplish cross promotion, news dissemination and customer service.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Designed and maintained database-driven data content using Caspio and custom database solutions, as well as Tableau visualizations for interactive data presentations.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Wrote and maintained wide array of documentation for online staff wiki.
                        </td>
                    </tr>
                </table>
                <h3>Reporter for the Anderson Independent-Mail / <a href="http://www.independentmail.com" target="_blank">independentmail.com</a></h3>
                <p><em>Then-E.W. Scripps market (now Gannett) in <a href="https://www.google.com/maps/place/Anderson+Independent-Mail/@34.5299115,-83.0688439,8.42z/data=!4m5!3m4!1s0x88586dac4883fb8d:0x1471a27ee88ec5fd!8m2!3d34.5028684!4d-82.6133049" target="_blank">Anderson, an Upstate South Carolina suburb of Greenville</a></em></p>
                <p><strong>1998 to 2005.</strong> Reporter</p>
                <table class="ui striped table fluid">
                    <tr>
                        <td>
                            Developed network of local, state and national sources to report and write state- and national-award-winning news stories, focused on health/medical, environment and university research topics that improved the knowledge of readers and reputation of the
                            newspaper.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Pioneered multimedia presentations in the early days of newspaper interactive web content in 2005 by conceiving, planning, reporting and executing interactive stories with the help of our staff developer.
                        </td>
                    </tr>
                </table>
                <p><strong>1996 to 2005.</strong> News page designer and copy editor</p>
                <table class="ui striped fluid table">
                    <tr>
                        <td>
                            Wrote effective and efficient headlines, winning internal, state and corporate-level awards.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Improved the newspaper’s reputation by eliminating common grammatical, spelling and factual errors.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Designed news pages on a daily and special-project basis, which earned state and national awards.
                        </td>
                    </tr>
                </table>
                <h2>Education</h2>
                <h3>Professional education</h3>
                <p><strong>Georgia Tech/Trilogy Full-Stack (MERN) Coding Bootcamp</strong></p>
                <p>January-July 2017: 6-month intensive front- and back-end classroom instruction on cutting edge development platforms, frameworks, libraries, architectures and version control systems, including:</p>
                <table class="ui striped fluid table">
                    <tr>
                        <td>
                            javascript/jQuery
                        </td>
                        <td>
                            JSON, AJAX and API development
                        </td>
                        <tr>
                            <td>
                                Git/GitHub
                            </td>
                            <td>
                                Bootstrap and other front-end frameworks
                            </td>
                        </tr>
                        <tr>
                            <td>
                                NodeJs/Express servers
                            </td>
                            <td>
                                MySQL
                            </td>
                        </tr>
                        <tr>
                            <td>
                                View engines (focus area: Handlebars)
                            </td>
                            <td>
                                ORMs (focus area: Sequelize)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                MongoDB
                            </td>
                            <td>
                                ODMS (focus area: Mongoose)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                ReactJs
                            </td>
                            <td></td>
                        </tr>
                </table>

                <p><strong>United Way of the Midlands</strong></p>
                <p>Columbia, SC, Feb-May 2013: Blueprint, a course hosted by the United Way of the Midlands for the purpose of developing professional volunteer board members for the community’s independent sector.
                </p>
                <p>
                    <strong>Tri-County Technical College, Pendleton, SC, 2004-05</strong></p>
                <p>Not a degree program. Courses in computer technology, Web development and multimedia presentations.
                </p>
                <h3>Formal education</h3>
                <p>
                    <strong>Pacific Lutheran University</strong>
                </p>
                <p>Tacoma, Wash., May 1996: Summa cum laude (3.92 out of 4.0) graduate of College of Arts and Science; bachelor of arts degree in communication with double major in print journalism and United States history.
                </p>
                <p>
                    <strong>South Kitsap High School</strong>
                </p>
                <p>Port Orchard, Wash., June 1992; valedictorian in class of 600; as senior class vice president, represented class in various ways and managed fundraisers and our graduation ceremony; 20th reunion committee member.
                </p>
                <h2>Awards/Achievements</h2>
                <table class="ui striped fluid table">
                    <tr>
                        <td>
                            2013, 2014, 2017: McClatchy Newspapers Presidents Award for production role on major enterprise projects (<a href="http://media.islandpacket.com/static/news/i95/" target="_blank" data-toggle="tooltip" title="I-95'S coffin corridor: Trees too close to road are killing motorists">dangerous conditions on Interstate 95</a>,
                            <a href="http://media.islandpacket.com/static/news/workforce" target="_blank" data-toggle="tooltip" title="Propping up paradise: Hilton Head's workforce crisis">Hilton Head workforce challenges</a>), creating and contributing
                            to the management of an SC Military News page
                        </td>
                    </tr>
                    <tr>
                        <td>
                            2017: SC Press Association Digital Feature Project (Hurricane Matthew survivor stories)
                        </td>
                    </tr>
                    <tr>
                        <td>
                            2011-2012: Hampton Award winner, a State Newspaper honor recognizing outstanding work by newsroom professionals
                        </td>
                    </tr>
                    <tr>
                        <td>
                            2011: 1st place, Best use of Twitter, South Carolina Press Association (SCPA); inaugural year for this award
                        </td>
                    </tr>
                    <tr>
                        <td>
                            2010: AP award of excellence: Recognition for top AP Video stream performance
                        </td>
                    </tr>
                    <tr>
                        <td>
                            2009, 2008: 1st place, newspaper Web site, SCPA
                        </td>
                    </tr>
                    <tr>
                        <td>
                            2005: 1st place, beat reporting, and 1st place, feature writing, SCPA
                        </td>
                    </tr>
                    <tr>
                        <td>
                            2004: 1st place, Religion Comm. Council Wilbur Awards, for “No-Name Religion” series on nontraditional churches
                        </td>
                    </tr>
                    <tr>
                        <td>
                            2001: 1st place, American Planning Association national media awards, for "Anderson at a Crossroads" (team writing)
                        </td>
                    </tr>
                    <tr>
                        <td>
                            2000: 1st place, Public Service, SCPA, and 1st place, Am. Planning Assoc., for "Plotting a Course" (team writing)
                        </td>
                    </tr>
                    <tr>
                        <td>
                            1998: 1st place, Series of Articles and second place, Public Service, for “Pointing the Way” (as designer), SCPA
                        </td>
                    </tr>
                    <tr>
                        <td>
                            1992: National Merit Scholar finalist, South Kitsap High School, Port Orchard, Wash.
                        </td>
                    </tr>
                </table>`;
